import React from "react";
import Popup from "react-popup";
import { graphql } from "react-apollo";
import PLAN_UPGRADE_REQUEST_MUTATION from "../../../graphql/PlanUpgradeRequest";
import Banner from "../../../components/Banner/index";
import Footer from "../../../components/Footer/index";
import IsGuest from "../../../utils/IsGuest";
import {
  FREE_PLAN,
  FULL_PLAN,
  PRODUCERS_PLAN,
  VENUES_PLAN
} from "../../../constants";

class PlansPage extends React.Component {
  changePlan = (evt, type) => {
    evt.preventDefault();
    const { mutate, history } = this.props;

    const url = `/theaterRegister?plan=${type}`;

    if (!IsGuest()) {
      mutate({
        variables: {
          plan: type
        }
      })
        .then(res => {
          if (res.data.planUpgradeRequest) {
            Popup.alert(
              "Los administradores han sido notificados y serás contactado prontamente."
            );
          } else {
            Popup.alert(
              "No estás asociado a un teatro. Por ende no puedes actualizar tu plan"
            );
          }
        })
        .catch(() => {
          Popup.alert("Ocurrió un problema notificando a los administradores.");
        });
    } else {
      history.push(url);
    }
  };

  render() {
    return (
      <div>
        <Banner />
        <div className="sub-banner">
          <div className="overlay">
            <div className="container">
              <div className="breadcrumb-area">
                <div className="top">
                  <h1>Membresías</h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="typography-page">
          <div className="container p-1">
            <div className="row">
              <h3 className="headline">Nuestras membresías</h3>
              <p>
                Para contratar estas membresías, contáctanos en:{" "}
                <a href="mailto:hello@escena.digital">hello@escena.digital</a>
              </p>
            </div>
            <div className="row mrg-btn-40">
              <h4 className="headline" style={{ marginTop: 20 }}>
                Artistas: US$100/year&nbsp;&nbsp;
                <small>US$100/año</small>
              </h4>
            </div>
            <div className="row mrg-btn-40">
              <h4 className="headline" style={{ marginTop: 20 }}>
                Teatros:
              </h4>
              <table className="pricing-table">
                <thead>
                  <tr>
                    <th />
                    <th>Free / Gratis</th>
                    <th>Producers / US$500</th>
                    <th>Venues / US$500</th>
                    <th>Full / US$800</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <strong>Periodo membresía</strong> <br />{" "}
                      <span>Membership</span>{" "}
                    </td>
                    <td>
                      Sin límite <br /> <span>Unlimited</span>
                    </td>
                    <td>
                      1 año <br /> <span>1 year</span>
                    </td>
                    <td>
                      1 año <br /> <span>1 year</span>
                    </td>
                    <td>
                      1 año <br /> <span>1 year</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Perfil</strong> <br /> <span>Profile</span>{" "}
                    </td>
                    <td>
                      Sí
                      <br /> <span>Yes</span>
                    </td>
                    <td>
                      Sí
                      <br /> <span>Yes</span>
                    </td>
                    <td>
                      Sí
                      <br /> <span>Yes</span>
                    </td>
                    <td>
                      Sí
                      <br /> <span>Yes</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Fotos de perfil</strong> <br />
                      <span>Profile picture</span>
                    </td>
                    <td>
                      1<br />
                      <span>1</span>
                    </td>
                    <td>
                      10
                      <br />
                      <span>10</span>
                    </td>
                    <td>
                      10
                      <br />
                      <span>10</span>
                    </td>
                    <td>
                      10
                      <br />
                      <span>10</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Carácteres en biografía</strong> <br />
                      <span>Bio characters</span>
                    </td>
                    <td>
                      0<br />
                      <span>0</span>
                    </td>
                    <td>
                      1000
                      <br />
                      <span>1000</span>
                    </td>
                    <td>
                      1000
                      <br />
                      <span>1000</span>
                    </td>
                    <td>
                      1000
                      <br />
                      <span>1000</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Ficha de producción</strong> <br />
                      <span>Production upload</span>
                    </td>
                    <td>
                      1<br />
                      <span>1</span>
                    </td>
                    <td>
                      10
                      <br />
                      <span>10</span>
                    </td>
                    <td>
                      -<br />
                      <span>-</span>
                    </td>
                    <td>
                      20
                      <br />
                      <span>20</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Ficha de teatro</strong> <br />
                      <span>Venue Profile</span>
                    </td>
                    <td>
                      <i className="fa fa-times red-icon" />
                    </td>
                    <td>
                      <i className="fa fa-times red-icon" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Usuarios</strong> <br />
                      <span>Users</span>
                    </td>
                    <td>
                      1<br />
                      <span>1</span>
                    </td>
                    <td>
                      2<br />
                      <span>2</span>
                    </td>
                    <td>
                      2<br />
                      <span>2</span>
                    </td>
                    <td>
                      4<br />
                      <span>4</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Recepción boletín bimensual</strong> <br />
                      <span>Newsletter</span>
                    </td>
                    <td>
                      Básico
                      <br />
                      <span>Basic</span>
                    </td>
                    <td>
                      Bimensual en teatros
                      <br />
                      <span>Bimonthly on venues</span>
                    </td>
                    <td>
                      Bimensual en producciones
                      <br />
                      <span>Bimontly on productions</span>
                    </td>
                    <td>
                      Completo + Artistas
                      <br />
                      <span>Full + Artists</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>
                        Ver fichas completas de otros usuarios con descargables
                      </strong>
                      <br />
                      <span>Access other users profile with downloadables</span>
                    </td>
                    <td>
                      <i className="fa fa-times red-icon" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Acceso a fichas del kit de herramientas</strong>
                      <br />
                      <span>Access to Toolkit files</span>
                    </td>
                    <td>
                      <i className="fa fa-times red-icon" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Analíticas</strong>
                      <br />
                      <span>Analytics</span>
                    </td>
                    <td>
                      <i className="fa fa-times red-icon" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Contacto directo al encargado del teatro</strong>
                      <br />
                      <span>
                        Direct contact to theatre representative for Escena
                      </span>
                    </td>
                    <td>
                      <i className="fa fa-times red-icon" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                    <td>
                      <i className="fa fa-check" />
                    </td>
                  </tr>
                  <tr>
                    <td />
                    <td>
                      <button
                        onClick={e => this.changePlan(e, FREE_PLAN)}
                        className="button-md button-theme"
                      >
                        Suscríbete
                      </button>
                    </td>
                    <td>
                      <a
                        href=""
                        onClick={e => this.changePlan(e, PRODUCERS_PLAN)}
                        className="button-md button-theme"
                      >
                        Suscríbete
                      </a>
                    </td>
                    <td>
                      <a
                        href=""
                        onClick={e => this.changePlan(e, VENUES_PLAN)}
                        className="button-md button-theme"
                      >
                        Suscríbete
                      </a>
                    </td>
                    <td>
                      <a
                        href=""
                        onClick={e => this.changePlan(e, FULL_PLAN)}
                        className="button-md button-theme"
                      >
                        Suscríbete
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withMutation = graphql(PLAN_UPGRADE_REQUEST_MUTATION);
export default withMutation(PlansPage);



// WEBPACK FOOTER //
// ./src/containers/General/PlansPage/index.js